<h1 mat-dialog-title class="heading">Add New Options</h1>
@if (form?.controls) {
  <div mat-dialog-content class="content-container">
    <form [formGroup]="form" class="add-options-form">
      <mat-form-field
        [matTooltip]="optionsToolTip">
        <textarea
          #message
          [attr.data-testid]="'dropdown_options'"
          formControlName="options"
          matInput
          placeholder="Add option values separated by comma"
          (focusout)="optionsValidation()"
        ></textarea>
        @if (form.controls['options'].invalid && !specialCharactersFound) {
          <mat-error>
            Add values separated by comma.
          </mat-error>
        }
        @if (form.controls['options'].invalid && specialCharactersFound) {
          <mat-error>
            Special characters are not allowed.
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
}
<div class="action-container">
  <button
    mat-raised-button
    type="button"
    (click)="onNoClick()">Cancel
  </button>
  @if (form?.controls) {
    <button
      matTooltip="Return to the form to save your new options"
      (click)="continue()"
      [disabled]="this.form.invalid || !this.form.dirty"
      mat-raised-button
      type="button"
      >Continue
    </button>
  }
</div>
